import axios from "axios/index";

const env = process.env;
const ServiceApi = axios;

ServiceApi.defaults.timeout = 20000;
ServiceApi.defaults.baseURL = env.REACT_APP_API_URL;

// ServiceApi.refreshToken = () => {
//   const token = ServiceStorage.getToken();
//   if (token)
//     axios.defaults.headers.common["Authorization"] = "Bearer " + token;
//   else return;

//   return ServiceApi.getTokenWithToken()
//     .then((res) => {
//       ServiceStorage.setAccessTokenExpireTime(res.accessTokenExpiresAt);
//       ServiceStorage.setAccessToken(res.access_token);
//       ServiceApi.takeToken();
//       return Promise.resolve(res);
//     })
//     .catch((err) => {
//       ServiceStorage.clearToken();
//       return Promise.reject(err);
//     });
// };

export default ServiceApi;
